import { connect } from 'react-redux';
import PaymentStatusTitle from './PaymentStatusTitle';

/**
 * Parses purchase and payment status into the title translation context.
 *
 * @param {string} status - Purchase status used as the primary title context.
 * @param {string} type - Payment type.
 * @param {string} paymentStatus - Payment status.
 * @param {string} paymentProvider - Payment provider.
 * @param {string} paymentEngine - Payment engine.
 * @param {string} purchaseState - Purchase state.
 * @param {boolean} purchaseIsExpired - Indicates if the purchase expired.
 * @returns {string} Payment status title context.
 */
export function parseTitle(
  status,
  type,
  paymentStatus,
  paymentProvider,
  paymentEngine,
  purchaseState,
  purchaseIsExpired,
) {
  switch (status) {
    case 'attempt':
      if (paymentProvider === 'pix') return 'pending';
      if (type === 'paypal' && purchaseIsExpired && paymentStatus === 'pending') return 'rejected';
      if (type === 'paypal') return 'pending';
      if (type === 'third_party') return 'pending';
      if (paymentEngine === 'evertec' && paymentStatus !== 'failed') return 'process';
      if (paymentEngine === 'stripe' && paymentStatus !== 'failed') return 'pendingCompleted';
      if (paymentEngine === 'yuno' && paymentStatus !== 'failed') return 'pendingCompleted';
      return status;
    case 'pending':
      if (paymentStatus === 'charged') return 'pendingCompleted';
      if (type === 'credit_card' || type === 'paypal' || type === 'transfer') return 'completed';
      return status;

    default:
      return status;
  }
}

const mapStateToProps = ({ purchase, payment }) => {
  const purchaseStatus = purchase.get('state') || payment.get('purchaseState');
  const purchaseEmail = purchase.get('email');
  const paymentStatus = payment.get('status');
  const paymentProvider = payment.get('paymentProvider');
  const paymentType = payment.get('paymentType') || 'credit_card';
  const isExchange = purchase.get('isExchange');
  const total = purchase.get('total');
  const paymentEngine = payment.get('paymentEngine');
  const purchaseState = purchase.get('state');
  const purchaseIsExpired = purchase.get('isExpired');

  return {
    titleStatus: parseTitle(
      purchaseStatus,
      paymentType,
      paymentStatus,
      paymentProvider,
      paymentEngine,
      purchaseState,
      purchaseIsExpired,
    ),
    isExchange,
    purchaseEmail,
    total,
  };
};

export default connect(mapStateToProps)(PaymentStatusTitle);
